module.exports = __webpack_public_path__ + "static/media/car-buyers.d5cf3c37.png";